import React from "react";
import { Row, Col, Skeleton, Card } from "antd";

const ProductDetailSkeleton = () => {
  return (
    <div style={{ padding: "24px" }}>
      <Row gutter={[24, 24]}>
        {/* Image Section */}
        <Col xs={24} md={12}>
          <Card variant="outlined" style={{ height: "100%" }}>
            <Skeleton.Image active style={{ width: 350, height: 350 }} />
            <Row gutter={8} style={{ marginTop: 16 }}>
              {[...Array(4)].map((_, index) => (
                <Col key={index}>
                  <Skeleton.Image active style={{ width: 60, height: 60 }} />
                </Col>
              ))}
            </Row>
          </Card>
        </Col>

        {/* Info Section */}
        <Col xs={24} md={12}>
          <Card variant={"outlined"}>
            <Skeleton
              active
              title={{ width: "60%" }}
              paragraph={{ rows: 1, width: ["30%"] }}
            />
            <Skeleton active paragraph={{ rows: 1, width: ["40%"] }} />
            <Skeleton
              active
              paragraph={{ rows: 3, width: ["100%", "100%", "60%"] }}
            />
            <Skeleton.Button
              active
              style={{ width: "100%", height: 40, marginTop: 20 }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ProductDetailSkeleton;
